module.exports = __webpack_public_path__ + "img/no-data-file.31660663.svg";